import React, { useState, useEffect } from 'react';
import './HomeSection.css';
import { FaMapMarkerAlt,FaPhone,FaEnvelope } from 'react-icons/fa';

const slides = [
  { image: 'images/Ba20/BA 20 (1).jpg', text: 'Experience in Advanced Architecture' },
  { image: 'images/Ba21/BA 21 (4).jpg', text: 'Innovative Design Solutions' },
  { image: 'images/BAM 32/BAM 32 (2).jpg', text: 'Sustainable Building Practices' },
  { image: 'images/BAM 33/BAM 33 (1).jpg', text: 'Smart Construction Techniques' },
  { image: 'images/3d web/3d (10).jpg', text: '3D Modeling and Visualization' },
  { image: 'images/Shafiya/Shafiya (1).jpg', text: 'Creative Interior Design' },
  { image: 'images/3d web/3d (9).jpg', text: 'Virtual Reality in Architecture' },
  { image: 'images/BAM 36/BAM 36 (3).jpg', text: 'Urban Development Projects' },
  { image: 'images/BAM 35/BAM 35 (2).jpg', text: 'Project Management Excellence' },
  { image: 'images/BAM 34/BAM 34 (7).jpg', text: 'Renovation and Restoration' }
];

function HomeSection() {
    const [currentSlide, setCurrentSlide] = useState(0);

  const nextImage = () => {
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  const prevImage = () => {
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 3000); 
    return () => clearInterval(interval);
  }, [currentSlide]);

    return(
       
       
      <div  className='carousel-container'>
       
        <img src={slides[currentSlide].image}  className="carousel-image" />
      <div className="hero-content">
        <h1><span>Build</span> Angles</h1>
        <h2>It's Your Dream We Build</h2>
        <h4><FaMapMarkerAlt className='icen' /> No 161, Meethotamulla,Dematagoda</h4>
        <h4><FaPhone className='icen'/> 074 394 6545 | 074 394 6544 | 077 789 5606</h4>
        <h4><FaEnvelope className='icen'/> baengineerings@gmail.com</h4>
        <div className="slider-text">{slides[currentSlide].text}</div> 
      </div>
      </div>
    );


}

export default HomeSection;